export const DAYS_TO_TRACK_OR_RETURN_ORDERS = 60
export const EMAIL_FORM_NAME = 'email'
export const PASSWORD_FORM_NAME = 'password'
